export const CALENDAR_UPDATE_LOADING = 'CALENDAR_UPDATE_LOADING'
export const CALENDAR_FETCH = 'CALENDAR_FETCH'
export const CALENDAR_FETCH_SUCCESS = 'CALENDAR_FETCH_SUCCESS'
export const CALENDAR_UPDATE_USERS = 'CALENDAR_UPDATE_USERS'
export const CALENDAR_UPDATE_USER_COLORS = 'CALENDAR_UPDATE_USER_COLORS'
export const CALENDAR_UPDATE_EVENT_TYPES = 'CALENDAR_UPDATE_EVENT_TYPES'
export const CALENDAR_UPDATE_EVENT_TYPE_COLORS = 'CALENDAR_UPDATE_EVENT_TYPE_COLORS'
export const CALENDAR_SET_DATE_RANGE = 'CALENDAR_SET_DATE_RANGE'
export const CALENDAR_MARK_COMPLETE = 'CALENDAR_MARK_COMPLETE'
export const CALENDAR_DELETE_EVENT = 'CALENDAR_DELETE_EVENT'
export const CALENDAR_SET_USERS_SETTINGS = 'CALENDAR_SET_USERS_SETTINGS'
export const CALENDAR_FETCH_USERS_SETTINGS = 'CALENDAR_FETCH_USERS_SETTINGS'
export const CALENDAR_FETCH_USERS_SETTINGS_SUCCESS = 'CALENDAR_FETCH_USERS_SETTINGS_SUCCESS'
export const CALENDAR_FETCH_USER_DATA = 'CALENDAR_FETCH_USER_DATA'
export const CALENDAR_SET_VIEW = 'CALENDAR_SET_VIEW'
export const CALENDAR_SET_DATE = 'CALENDAR_SET_DATE'
export const CALENDAR_UPDATE_EVENT = 'CALENDAR_UPDATE_EVENT'
export const CALENDAR_UPDATE_EVENT_STATE = 'CALENDAR_UPDATE_EVENT_STATE'
export const CALENDAR_FETCH_FILTERS = 'CALENDAR_FETCH_FILTERS'
export const CALENDAR_FETCH_FILTERS_SUCCESS = 'CALENDAR_FETCH_FILTERS_SUCCESS'
export const CALENDAR_CREATE_FILTER = 'CALENDAR_CREATE_FILTER'
export const CALENDAR_CREATE_FILTER_SUCCESS = 'CALENDAR_CREATE_FILTER_SUCCESS'
export const CALENDAR_UPDATE_FILTER = 'CALENDAR_UPDATE_FILTER'
export const CALENDAR_UPDATE_FILTER_SUCCESS = 'CALENDAR_UPDATE_FILTER_SUCCESS'
export const CALENDAR_DELETE_FILTER = 'CALENDAR_DELETE_FILTER'
export const CALENDAR_DELETE_FILTER_SUCCESS = 'CALENDAR_DELETE_FILTER_SUCCESS'
export const CALENDAR_SELECT_FILTER = 'CALENDAR_SELECT_FILTER'
export const CALENDAR_SELECT_FILTER_SUCCESS = 'CALENDAR_SELECT_FILTER_SUCCESS'
export const CALENDAR_SELECT_DEFAULT_FILTER = 'CALENDAR_SELECT_DEFAULT_FILTER'

// FILES
export const CALENDAR_FETCH_FILES = 'CALENDAR_FETCH_FILES'
export const CALENDAR_LOAD_FILES = 'CALENDAR_LOAD_FILES'
export const CALENDAR_CREATE_FILE = 'CALENDAR_CREATE_FILE'
export const CALENDAR_DELETE_FILE = 'CALENDAR_DELETE_FILE'

export const CALENDAR_EVENT_TYPE_ICONS = {
  CalendarTask: 'far fa-calendar-check',
  CalendarTaskOverdue: 'fas fa-exclamation-circle',
  CalendarEvent: 'far fa-calendar-alt',
  CalendarProject: 'far fa-folder',
  CalendarProjectMilestone: 'far fa-calendar-image'
}

// Backend contract: `recurrence_frequency` is a virtual attribute on
// CalendarEntry (app/models/calendar_entry.rb). The setter looks up the
// submitted string in FREQUENCY_TO_RRULE (calendar_entry.rb:44) — anything
// not in this exact set silently disables recurrence (sets rrule = nil).
// Treat the values below as the only safe payload values for the API.
// Display labels are translated separately via RECURRENCE_FREQUENCY_LABEL_KEYS.
//
// **Declaration order = picker order.** CALENDAR_REPEAT_OPTIONS below is
// `Object.values(RECURRENCE_FREQUENCY)`, so reordering the keys here
// reorders the dropdown in TaskEvent.jsx + AddTaskModal.js.
export const RECURRENCE_FREQUENCY = Object.freeze({
  DOESNT_REPEAT: "Doesn't Repeat",
  DAILY: 'Daily',
  EVERY_WEEKDAY: 'Every Weekday',
  WEEKLY: 'Weekly',
  WEEKLY_MON_WED_FRI: 'Weekly on Monday, Wednesday, Friday',
  WEEKLY_TUE_THU: 'Weekly on Tuesday, Thursday',
  EVERY_TWO_WEEKS: 'Every two weeks',
  MONTHLY: 'Monthly',
  EVERY_3_MONTHS: 'Every 3 months',
  EVERY_6_MONTHS: 'Every 6 months',
  YEARLY: 'Yearly'
})

export const CALENDAR_REPEAT_OPTIONS = Object.values(RECURRENCE_FREQUENCY)

// Maps the English API value to the locale key that renders its translated
// display label. Includes 'Custom', which the backend returns on read for
// rrules that don't match a preset (not selectable in the picker — display
// only). Consumers should use getRecurrenceLabel() below.
export const RECURRENCE_FREQUENCY_LABEL_KEYS = Object.freeze({
  [RECURRENCE_FREQUENCY.DOESNT_REPEAT]: 'addEditModals.formField.recurrence.doesntRepeat',
  [RECURRENCE_FREQUENCY.DAILY]: 'addEditModals.formField.recurrence.daily',
  [RECURRENCE_FREQUENCY.EVERY_WEEKDAY]: 'addEditModals.formField.recurrence.everyWeekday',
  [RECURRENCE_FREQUENCY.WEEKLY]: 'addEditModals.formField.recurrence.weekly',
  [RECURRENCE_FREQUENCY.WEEKLY_MON_WED_FRI]: 'addEditModals.formField.recurrence.weeklyMonWedFri',
  [RECURRENCE_FREQUENCY.WEEKLY_TUE_THU]: 'addEditModals.formField.recurrence.weeklyTueThu',
  [RECURRENCE_FREQUENCY.EVERY_TWO_WEEKS]: 'addEditModals.formField.recurrence.everyTwoWeeks',
  [RECURRENCE_FREQUENCY.MONTHLY]: 'addEditModals.formField.recurrence.monthly',
  [RECURRENCE_FREQUENCY.EVERY_3_MONTHS]: 'addEditModals.formField.recurrence.every3Months',
  [RECURRENCE_FREQUENCY.EVERY_6_MONTHS]: 'addEditModals.formField.recurrence.every6Months',
  [RECURRENCE_FREQUENCY.YEARLY]: 'addEditModals.formField.recurrence.yearly',
  Custom: 'addEditModals.formField.recurrence.custom'
})

// Resolves a backend `recurrence_frequency` value to the user-facing label
// for the current locale. Returns null for blank input; falls back to the
// raw value if the backend returns an unrecognized string (defensive against
// schema drift — we don't want to render an undefined or i18n key path).
export const getRecurrenceLabel = (frequency, t) => {
  if (!frequency) return null
  const key = RECURRENCE_FREQUENCY_LABEL_KEYS[frequency]
  return key ? t(key) : frequency
}
